// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Tooltip } from '../base';
import { HelpOutline } from '../icons';

interface Props {
  tooltip: string;
}
export default function Help({ tooltip }: Props): React.ReactElement {
  return (
    <Tooltip sx={{ cursor: 'pointer' }} title={tooltip} placement="bottom">
      <HelpOutline fontSize="small" />
    </Tooltip>
  );
}
